import React from 'react';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import { Grid } from 'antd';
import ChooseTicketDesktop from './Desktop';
import ChooseTicketMobile from './Mobile';
const { useBreakpoint } = Grid;

function GetBreakPoint() {
  const screens = useBreakpoint()
  return screens;
}

export default function XpertDetail(props) {
  const { lg } = GetBreakPoint()

  if(process.env.REACT_APP_ENV === "production"){
    ReactGA.pageview(`${window.location.pathname}${window.location.search}`, [], 'Xpert - Choose Ticket');
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Xpert - Choose Ticket</title>
      </Helmet>
      {
        lg ?
          <ChooseTicketDesktop {...props} />
        :
          <ChooseTicketMobile {...props} />
      }
    </React.Fragment>
  )
}
